import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-workplaces',
    template: require('../shared/list-view.html')
})
export class Workplaces extends ListBase<Nema.Crew.Model.Workplace>  {
    constructor(
        @Inject("workplaces") workplaces: Nema.Crew.Model.Workplace[],
        crewPermissionsService: CrewPermissionsService) {

        super(workplaces, crewPermissionsService);
    }

    public newEntityState = "app.settings.workplaces.new";

    public editEntityState = "app.settings.workplaces.detail";

    public entityName = "Workplace";

    public entityNames = "Workplaces";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/workplaces/workplaces.component.ts